import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DataStateChangeEventArgs, FilterSettingsModel, GridComponent, TextWrapSettingsModel } from '@syncfusion/ej2-angular-grids';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';
import { EmployeeBO, functionpermission, getEmployee, GetEmployeeListBO, IsViewEdit } from '../employee.model';
import { EmployeeService } from '../employee.service';
import { EmployeeListService } from '../employeelistdateservice';
import { onboardingservice } from '../../onboarding/onboarding.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-employee-list',
  templateUrl: './employee-list.component.html',
  styleUrls: ['./employee-list.component.scss']
})
export class EmployeeListComponent implements OnInit {
  @Input() ViewEdit: IsViewEdit;
  @Output() isViewEdit = new EventEmitter<IsViewEdit>();
  EmployeeListData: getEmployee = new getEmployee();
  isEdit: boolean = false;
  isView: boolean = false;
  EmployeeTypeItems: any = [];
  private onDestroy$: Subject<void> = new Subject<void>();
  isEditEmployee: boolean = false;
  @ViewChild('gridEmployee') public gridEmployee: GridComponent;
  // public data: Observable<DataStateChangeEventArgs>;
  filterOptions: FilterSettingsModel;
  initialPage: object;
  searchText:string
  FilteremployeeTypeLid:any="00000000-0000-0000-0000-000000000000";
  public filterSettings: object;
  public formatOptions1: object;
  public formatOptions: object;
  locationId: any = null;
  EmployeestatusList: any = [];
  EmployeeFilterBo: GetEmployeeListBO = new GetEmployeeListBO();
  public wrapSettings: TextWrapSettingsModel;
  public EmployeeGridData: Observable<DataStateChangeEventArgs>;
  fp: functionpermission = new functionpermission();
  constructor(public global: GlobalComponent,
    private employeeService: EmployeeService,
    public httpService: onboardingservice,
    public  toastrService:ToastrService,
    public EService: EmployeeListService) {
    this.EmployeeGridData = EService;
    this.global.checkforlogout();

  }

  ngOnInit(): void {    
    if (this.global.globalAgencyId == null ||
      this.global.globalAgencyId == undefined ||
      this.global.globalAgencyId == "" ||
      this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000") 
     {
      return;
    }
    this.getEmployeeStatus();
    this.getEmployeetype();
    if (this.global.selectedLocationDropdown == null || this.global.selectedLocationDropdown == undefined || this.global.selectedLocationDropdown == '') {
      this.locationId = null;
    }
    else {
      this.locationId = this.global.selectedLocationDropdown;
    }

    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };
    this.wrapSettings = { wrapMode: 'Content' };
    this.filterOptions = { type: 'Excel' };
    this.filterSettings = { type: 'Menu' };
    this.formatOptions1 = { type: 'date', format: 'MM/dd/yyyy HH:mm:ss' };

    this.initialPage = { pageSizes: ['10', '20', '50', '100', '250'], pageSize: 10 };
    this.getpermission()

  }
  getpermission() {
    
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId!=null&&this.global.globalAgencyId!=undefined&&this.global.globalAgencyId!='')) {
    let params = new URLSearchParams();
    params.append("pagecode", "employee");
    params.append("roleId", this.global.roleId);
    params.append("agencyId", this.global.globalAgencyId)
    this.employeeService.getEmployeepermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      if (data != null) {
        this.fp = data;

      }
      else {
        this.fp = new functionpermission();
      }
    },
      (err:any) => {
        this.fp = new functionpermission();
      })
  }
}

  //..................................................editEmployee........................................
  editEmployee(edit) {
    if (edit == 'new') {
      this.isViewEdit.emit({
        isView: false, isEdit: true, isEditEmployee: false, editEmployee: "00000000-0000-0000-0000-000000000000",
        Employeedata: new EmployeeBO(), isEmployeefilterEnable: true, EmployeefilterDetails: this.EmployeeListData,
        isaEmployeeNew: true
      });
      this.isEditEmployee = false;
    }
    else {
      this.isViewEdit.emit({
        isView: false, isEdit: true, isEditEmployee: true, editEmployee: edit.id, isaEmployeeNew: false,
        Employeedata: edit, isEmployeefilterEnable: true, EmployeefilterDetails: this.EmployeeListData
      });
      this.isEditEmployee = true;
    }
    this.global.employeetoAgreementEmit = false
  }
  //..................................................getEmployeeFilter........................................
  getEmployeeFilter() {
    this.EmployeeFilterBo.locationID = this.locationId;
    if (this.FilteremployeeTypeLid == "00000000-0000-0000-0000-000000000000") {
      this.EmployeeFilterBo.employeeTypeLid = null;
    }
    else 
    {
      this.EmployeeFilterBo.employeeTypeLid = this.FilteremployeeTypeLid
    }
    if(this.EmployeeFilterBo.type != "String" && (this.EmployeeFilterBo.value == null || this.EmployeeFilterBo.value == undefined || this.EmployeeFilterBo.value == '')){
      this.EmployeeFilterBo.field = "name";
      this.EmployeeFilterBo.matchCase = false;
      this.EmployeeFilterBo.operator = "contains";
      this.EmployeeFilterBo.value = "";
      this.EmployeeFilterBo.type = "string";
    }
    console.log(this.global.isUMPI,"isUMPI")
    this.EmployeeFilterBo.isUMPI=this.global.isUMPI
    this.EService.execute(this.EmployeeFilterBo);
    let count = 0;
    this.EmployeeGridData.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      count = count + 1;
      if (data != null && data.result.length > 15) {
        this.gridEmployee.height = '500';
      }
      else {
        this.gridEmployee.height = 'auto';
      }
    })
  }
  //..................................................show........................................
  show() {
    this.gridEmployee.columnChooserModule.openColumnChooser(500, 50);
  }

   // ................................................dataChangeEmployee..............................................
   public dataChangeEmployee(Lov): void {
    let val = (Lov.action.requestType).toString();
   
   
    if (val != "filterchoicerequest") {
      if ((Lov.sorted || []).length) {
        this.EmployeeFilterBo.orderColumn = Lov.sorted[0].name;
        this.EmployeeFilterBo.orderType = Lov.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (val == "filtering" && Lov.action.action != "clearFilter") {
      this.EmployeeFilterBo.value = Lov.action.currentFilterObject.value;
      this.EmployeeFilterBo.field = Lov.action.currentFilterObject.field;
      this.EmployeeFilterBo.matchCase = Lov.action.currentFilterObject.matchCase;
      this.EmployeeFilterBo.operator = Lov.action.currentFilterObject.operator;
      if(this.EmployeeFilterBo.type == "date" || this.EmployeeFilterBo.type == "datetime"){
        this.EmployeeFilterBo.value = (this.EmployeeFilterBo.value!= null && this.EmployeeFilterBo.value != "" && this.EmployeeFilterBo.value != undefined)
        ? this.global.getDateTimeString(this.EmployeeFilterBo.value)
        : this.EmployeeFilterBo.value;
      }

      if(this.EmployeeFilterBo.field == "statusLidName"){
        this.EmployeeFilterBo.type = "string";
        // this.EmployeeFilterBo.operator = "equal";
      }
    }
    else {
      if (val == "filtering" && Lov.action.action == "clearFilter") {
        this.EmployeeFilterBo.field = "name";
        this.EmployeeFilterBo.matchCase = false;
        this.EmployeeFilterBo.operator = "contains";
        this.EmployeeFilterBo.value = "";
        this.EmployeeFilterBo.type = "string";
      }
    }
    this.getEmployeeFilter();
    if (val == "paging" && Lov.action.name == "actionBegin") {
      // if (this.arraycol.length != 0) {
      //   if (this.arraycol[0].Question.Pagesize != Q.take) {
      //     this.arraycol[0].Question.Pagesize = Q.take
      //     // this.SaveColumnwidth();
      //   }
      // }
    }
  }
  //.........................................onActionEmployee.....................................................
  public onActionEmployee(Lov) {
    this.EmployeeFilterBo.currentpageno = this.gridEmployee.pagerModule.pagerObj.currentPage;
    this.EmployeeFilterBo.pageitem = this.gridEmployee.pagerModule.pagerObj.pageSize;
    if (Lov.name == "actionBegin" && Lov.requestType == "filterbeforeopen") {
      this.EmployeeFilterBo.type = Lov.columnType
    }
  }
  //..................................................getEmployeeStatus........................................
  getEmployeeStatus() {
    let params = new URLSearchParams();
    params.append("ListCode", "STATUS");
    this.employeeService.getLov(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.EmployeestatusList = data;
      let values =
      {
        "id": null,
        "lovName": "ALL",
        "lovCode": "ALL",
        "lovValue": "ALL"
      }
      this.EmployeestatusList.push(values);
      this.EmployeeFilterBo.statusLid = this.EmployeestatusList?.filter(st => st.lovCode == "ACTIVE")[0].id;
      this.getEmployeeFilter();      
    })
  }
  //..................................................getEmployeetype........................................
  getEmployeetype() {
    let params = new URLSearchParams();
    params.append("ListCode", "EMPLOYEETYPE");
    this.employeeService.getLov(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.EmployeeTypeItems = data;
      let values =
      {
        "id": "00000000-0000-0000-0000-000000000000",
        "lovName": "ALL",
        "lovCode": "ALL",
        "lovValue": "ALL"
      }
      this.EmployeeTypeItems.push(values);
      this.FilteremployeeTypeLid = this.EmployeeTypeItems?.filter(st => st.lovCode == "ALL")[0].id;

    })

  }
  public ngOnDestroy(): void {
    this.global.isUMPI=null
    this.onDestroy$.next();
  }
  refresh(){
    this.EmployeeFilterBo.statusLid = this.EmployeestatusList?.filter(st => st.lovCode == "ACTIVE")[0].id;
    this.EmployeeFilterBo.employeeTypeLid=null
    this.FilteremployeeTypeLid=null
    this.EmployeeFilterBo.value=""
    this.getEmployeeFilter();

  }


  exportCsv() {

    this.employeeService.getExportCsv().pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
    
      let contentType = 'text/csv';
      const blob = this.b64toBlob(data.fileContents,contentType);
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = "Employee Export";
      a.click(); 
    
   

    })
  }
   
    b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {

      const byteCharacters = atob(b64Data);
  
      const byteArrays = [];
  
      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
  
        const slice = byteCharacters.slice(offset, offset + sliceSize);
  
        const byteNumbers = new Array(slice.length);
  
        for (let i = 0; i < slice.length; i++) {
  
          byteNumbers[i] = slice.charCodeAt(i);
  
        }
  
        const byteArray = new Uint8Array(byteNumbers);
  
        byteArrays.push(byteArray);
  
      }
  
      const blob = new Blob(byteArrays, { type: contentType });
  
      return blob;
  
    }


    changeClientPortalPass() {
      if(this.username == null || this.username == undefined || this.username == '') {
        this.toastrService.error("This employee does not have a portal credential account.", 'Error'),8000;
        return;
      }
      let params = new URLSearchParams();   
        console.log("global.agencyCode",this.global.agencyCode,this.username)
        params.append("type","employee");
        params.append("Email",this.username);
        if(this.global.agencyCode == "SUPERADMIN")  {
          params.append("AgencyCode",this.global.selectAgencyCode);
        } else {
        params.append("AgencyCode",this.global.agencyCode);
        }
        this.httpService.forgotPasswordclient(params).subscribe((data: any) => {
          if (data) {
            this.toastrService.success('Temporary password has been sent to your respective mail id',
              'Temporary password sent successfully'), 8000;     
          }      
        }, (err: any) => {
          if (err) {
            this.toastrService.error(err, 'Error'), 8000;
          }
        })
    }
    username:any;
    
     resetpassword(data) {
      this.username=data.username;
    }

}

